import { BehaviorSubject, Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';

import * as jwt_decode from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { PersonaNatural } from '../models/persona-natural';
import { TokenRequest } from '../models/toquenRequest.model';


const httpOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
};
@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    restItems: any;
    private http: HttpClient;
    private onrefresh = false;
    private _isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isLoggedIn$: Observable<boolean> = this._isLoggedIn.asObservable();

    constructor(private handler: HttpBackend) {
        this.http = new HttpClient(handler);
    }

    obtenerTokenJWT(tokenRequest: TokenRequest) {
        const options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        };
        const body = { username: tokenRequest.username, password: tokenRequest.password };
        return this.http.post(`${environment.api_baseurl_token}/api/token/getToken`, JSON.stringify(body), options);
    }

    obtenerRefreshTokenJWT() {
        this.onrefresh = true;
        const options = this.getOption();
        const body = this.getBody();

        this.http.post(`${environment.api_baseurl_token}/api/token/getRefreshToken`, JSON.stringify(body), options)
            .subscribe((resRefreshToken: any) => {
                localStorage.setItem('auth.authToken', resRefreshToken.data['access_token']);
                localStorage.setItem('auth.refreshToken', resRefreshToken.data['refresh_token']);
                this.onrefresh = false;
            });
    }

    getOption() {
        return {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        };
    }

    getBody() {
        return {
            'access_token': '',
            'expires_in': 360,
            'token_type': 'Bearer',
            'refresh_token': localStorage.getItem('auth.refreshToken')
        };
    }

    obtenerTokenJWTAlmacenado() {
        if (window.localStorage) {
            if (localStorage.length > 0) {
                return localStorage.getItem('auth.authToken');
            } else {
                throw Error('No se encontró el token esperado en el sessionStorage bajo la llave auth.authToken.');
            }
        } else {
            throw Error('El explorador no soporta la API de local/sessionStorage. Intente con una versión mas reciente.');
        }
    }

    public get isLoggedIn(): boolean {
        let isLogged = true;
        const token = localStorage.getItem('auth.authToken');
        const refreshToken = localStorage.getItem('auth.refreshToken');

        if (isNullOrUndefined(token) && isNullOrUndefined(refreshToken)) {
            isLogged = false;
        } 

        if (isLogged !== this._isLoggedIn.getValue()) {
            this._isLoggedIn.next(isLogged);
        }

        return isLogged;
    }

    public logout() {
        const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
        const body = {
            'access_token': localStorage.getItem('auth.authToken'),
            'expires_in': 360,
            'token_type': 'Bearer',
            'refresh_token': ''
        };
        this.http.post(environment.api_baseurl_token + '/api/token/logout', JSON.stringify(body), options)
            .subscribe((res: any) => {

                // localStorage.removeItem('auth.authToken');
                // localStorage.removeItem('auth.refreshToken');
            });

        return true;
    }

    public onrefreshToken() {
        return this.onrefresh;
    }

    obtenerTiempoRestanteToken() {
        let time = 0;
        if (!isNullOrUndefined(localStorage.getItem('auth.authToken'))) {
            const token = jwt_decode(localStorage.getItem('auth.authToken'));
            const now = new Date().getTime() / 1000;
            time = (token.exp - now);
        }

        return time;
    }

}
